import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
const _excluded = ["id"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getMainApi, postMainApi, putMainApi, deleteMainApi } from "@Shared/utils/ajax";
import { pickBy } from "lodash";
export const get = async referrerId => {
  return getMainApi({}, `/client/referrer/${referrerId}`);
};
export const getSelectReferrers = async params => {
  const endpoint = "/client/referrer";
  if (params.searchString) params.searchString = encodeURIComponent(params.searchString);
  return getMainApi(pickBy(params, val => val != null && val !== ""), endpoint);
};
export const getAllReferrers = async (params = {}, pageSize = 200) => {
  const endpoint = "/client/referrer";
  const referrers = [];
  let referrerCount = 0;
  let offset = 0;
  do {
    const requestParams = _objectSpread(_objectSpread({}, params), {}, {
      offset,
      limit: pageSize
    });
    if (requestParams.searchString) requestParams.searchString = encodeURIComponent(requestParams.searchString);
    const response = await getMainApi(pickBy(requestParams, val => val != null && val !== ""), endpoint);
    referrerCount = Number(response.referrerCount) || 0;
    referrers.push(...response.referrers);
    if (response.referrers.length === 0) break;
    offset += response.referrers.length;
  } while (referrers.length < referrerCount);
  return {
    referrerCount,
    referrers
  };
};
export const getReferrerCustomFields = async () => {
  return getMainApi({}, "/client/referrer/custom-field");
};
export const getReferrerLinkedApps = async referrerId => {
  return getMainApi({
    referrerId
  }, `/client`);
};
export const getReferrerLinkedProfiles = async referrerId => {
  return getMainApi({
    referrerId
  }, `/client/profile`);
};
export const create = async data => {
  return postMainApi(data, "/client/referrer");
};
export const createReferrerCustomFieldDefinition = async data => {
  return postMainApi(data, "/client/referrer/custom-field");
};
export const update = async (referrerId, details) => {
  return putMainApi(details, `/client/referrer/${referrerId}`);
};
export const updateReferrerCustomFieldDeclaration = async _ref => {
  let {
      id: customFieldDefinitionId
    } = _ref,
    customFieldDefinition = _objectWithoutProperties(_ref, _excluded);
  return putMainApi(customFieldDefinition, `/client/referrer/custom-field/${customFieldDefinitionId}`);
};
export const updateReferrerCustomFieldOrder = async updatedCustomFieldDefinitions => {
  return putMainApi(updatedCustomFieldDefinitions, `/client/referrer/custom-field`);
};
export const remove = async referrerId => {
  return deleteMainApi(`/client/referrer/${referrerId}`);
};
export const removeReferrerCustomFieldDefinition = async customFieldId => {
  return deleteMainApi(`/client/referrer/custom-field/${customFieldId}`);
};
export const createReferrerChecklist = async (referrerId, checklist, title) => {
  return postMainApi({
    checklist,
    title
  }, `/client/referrer/${referrerId}/checklist`);
};
export const deleteReferrerChecklist = async (referrerId, checklistId) => {
  return deleteMainApi(`/client/referrer/${referrerId}/checklist/${checklistId}`);
};
export const saveReferrerChecklist = async (referrerId, checklistId, items, title) => {
  return putMainApi({
    checklist: items,
    title
  }, `/client/referrer/${referrerId}/checklist/${checklistId}`);
};
export const createReferrerFollowUp = async (referrerId, details) => {
  return postMainApi(details, `/client/referrer/${referrerId}/follow-up`);
};
export const deleteReferrerFollowUp = async (referrerId, followUpId) => {
  return deleteMainApi(`/client/referrer/${referrerId}/follow-up/${followUpId}`);
};
export const updateReferrerFollowUp = async (referrerId, followUpId, data) => {
  return putMainApi(data, `/client/referrer/${referrerId}/follow-up/${followUpId}`);
};
export const addReferrerNote = async (referrerId, note) => {
  return postMainApi({
    note
  }, `/client/referrer/${referrerId}/note`);
};
export const deleteReferrerNote = async (referrerId, noteId) => {
  return deleteMainApi(`/client/referrer/${referrerId}/note/${noteId}`);
};
export const updateReferrerNote = async (referrerId, noteId, data) => {
  return putMainApi(data, `/client/referrer/${referrerId}/note/${noteId}`);
};
export const toggleReferrerPin = async (referrerId, timelineItemType, id) => {
  return postMainApi({}, `/client/referrer/${referrerId}/${timelineItemType}/${id}/pin`);
};
export const getReferrerTimeline = async referrerId => {
  return getMainApi({}, `/client/referrer/${referrerId}/timeline`);
};
export const getReferrerChangelog = async referrerId => {
  return getMainApi({}, `/client/referrer/${referrerId}/changelog`);
};